import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: localStorage.getItem('nd-theme') || 'dark',
    lang: localStorage.getItem('nd-lang') || 'zh',
  },
  mutations: {
    toggleTheme (state) {
      state.theme = state.theme === 'dark' ? 'light' : 'dark'
      localStorage.setItem('nd-theme', state.theme)
    },
    toggleLang (state) {
      state.lang = state.lang === 'zh' ? 'en' : 'zh'
      localStorage.setItem('nd-lang', state.lang)
    },
  },
  actions: {},
  modules: {},
})
